import {
  saveIndustryTypeActions,
  deleteIndustryTypeActions,
  GetIndustryTypeDetailsActions,
  ClearFormDetailsActions,
  GetVendorTypeDetailsActions,
  SaveVendorTypeActions,
  SaveVendorCategoryActions,
  GetVendorCategoryDetailsActions,
  SaveVendorRegisterActions,
  GetVendorRegisterDetailsActions,
  GetActiveVendorTypeActions,
  GetActiveIndustryTypeActions,
  GetActiveVendorCategoryActions,
  DeleteVendorAddressActions,
  DeleteVendorContactActions,
  GetVendorTnCDocumentsActions,
  GetViewDocumentsActions,
  SaveVendorTnCDocumentsActions,
  UploadVenderDocumentActions,
  DeleteVendorTnCDocumentsActions,
  GetActiveVendorActions,
  GetVendorPortalDashboardActions,
} from "./actions";

const initState = {
  industrySuccessMessage: null,
  industryTypeErrorMessage: null,
  IndustryTypeStatus: null,
  IndustryTypeMaster: [],
  IndustryTypeData: null,
  ActiveIndustryTypeList: null,
  vendorTypeSuccessMessage: null,
  vendorTypeErrorMessage: null,
  vendorTypeStatus: null,
  vendorTypeMaster: [],
  vendorTypeData: null,
  ActiveVendorTypeList: null,
  vendorCategorySuccessMessage: null,
  vendorCategoryErrorMessage: null,
  vendorCategoryStatus: null,
  vendorCategoryMaster: [],
  vendorCategoryData: null,
  ActiveVendorCategoryList: null,
  vendorRegisterSuccessMessage: null,
  vendorRegisterErrorMessage: null,
  vendorRegisterStatus: null,
  vendorRegisterMaster: [],
  vendorRegisterData: null,
  ActiveVendorRegisterList: null,
  ActiveVendorList: [],
  vendorErrorMessage: null,
  venderViewDocumentData:null,
  venderViewErrorMsg:null,
  vendorPortalDashboard: null,
  vendorPortalDashboardError: null,
};

export default function VendorManagement(state = initState, { type, payload }) {
  switch (type) {
    //Save Industry
    case saveIndustryTypeActions.SAVE_INDUSTRY_TYPE:
      return {
        ...state,
        isLoading: true,
        industryTypeErrorMessage: null,
        modalActive: false,
      };
    case saveIndustryTypeActions.SAVE_INDUSTRY_TYPE_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        IndustryTypeStatus: payload.status,
        industryTypeErrorMessage: null,
        industrySuccessMessage: "Industry Type added successfully!",
      };

    case saveIndustryTypeActions.SAVE_INDUSTRY_TYPE_FAILURE:
      return {
        ...state,
        isLoading: false,
        IndustryTypeStatus: null,
        industryTypeErrorMessage: payload,
      };
    case saveIndustryTypeActions.SAVE_INDUSTRY_TYPE_STATUS:
      return {
        ...state,
        IndustryTypeStatus: 0,
        industryTypeErrorMessage: null,
      };

    // GET Industry By ID
    case GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS:
      return {
        ...state,
        isLoading: true,
        industryTypeErrorMessage: null,
        modalActive: false,
        IndustryTypeData: null,
      };
    case GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        IndustryTypeData: payload.data,
        IndustryTypeDataStatus: payload.status,
        industryTypeErrorMessage: null,
      };
    case GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        industryTypeErrorMessage: payload,
        IndustryTypeData: null,
      };
    case GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS_STATUS:
      return {
        ...state,
        IndustryTypeData: null,
      };

    ///Active Industry Type List
    case GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE:
      return {
        ...state,
        isLoading: true,
        assetTypeErrorMessage: null,
        modalActive: false,
        ActiveIndustryTypeList: null,
      };
    case GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        ActiveIndustryTypeList: payload.data,
        assetTypeErrorMessage: null,
      };
    case GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE_REJECTED:
      return {
        ...state,
        isLoading: false,
        assetTypeErrorMessage: payload,
        ActiveIndustryTypeList: null,
      };
    case GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE_STATUS:
      return {
        ...state,
        ActiveIndustryTypeList: null,
      };

    //SAVE Vendor Type
    case SaveVendorTypeActions.SAVE_VENDOR_TYPE:
      return {
        ...state,
        isLoading: true,
        vendorTypeErrorMessage: null,
        modalActive: false,
      };
    case SaveVendorTypeActions.SAVE_VENDOR_TYPE_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorTypeStatus: payload.status,
        vendorTypeErrorMessage: null,
        vendorTypeSuccessMessage: "Vendor Type Added Successfully!",
      };

    case SaveVendorTypeActions.SAVE_VENDOR_TYPE_FAILURE:
      return {
        ...state,
        isLoading: false,
        vendorTypeStatus: null,
        vendorTypeErrorMessage: payload,
      };
    case SaveVendorTypeActions.SAVE_VENDOR_TYPE_STATUS:
      return {
        ...state,
        vendorTypeStatus: 0,
        vendorTypeErrorMessage: null,
      };

    // GET Vendor Type  BY ID
    case GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS:
      return {
        ...state,
        isLoading: true,
        vendorTypeErrorMessage: null,
        modalActive: false,
        vendorTypeData: null,
      };
    case GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorTypeData: payload.data,
        vendorTypeDataStatus: payload.status,
        vendorTypeErrorMessage: null,
      };
    case GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorTypeErrorMessage: payload,
        vendorTypeData: null,
      };
    case GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS_STATUS:
      return {
        ...state,
        vendorTypeData: null,
      };

    ///Active Vendor Type List
    case GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE:
      return {
        ...state,
        isLoading: true,
        assetTypeErrorMessage: null,
        modalActive: false,
        ActiveVendorTypeList: null,
      };
    case GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        ActiveVendorTypeList: payload.data,
        assetTypeErrorMessage: null,
      };
    case GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE_REJECTED:
      return {
        ...state,
        isLoading: false,
        assetTypeErrorMessage: payload,
        ActiveVendorTypeList: null,
      };
    case GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE_STATUS:
      return {
        ...state,
        ActiveVendorTypeList: null,
      };

    //SAVE Vendor Category
    case SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY:
      return {
        ...state,
        isLoading: true,
        vendorCategoryErrorMessage: null,
        modalActive: false,
      };
    case SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorCategoryStatus: payload.status,
        vendorCategoryErrorMessage: null,
        vendorCategorySuccessMessage: "Vendor Category Added Successfully!",
      };

    case SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY_FAILURE:
      return {
        ...state,
        isLoading: false,
        vendorCategoryStatus: null,
        vendorCategoryErrorMessage: payload,
      };
    case SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY_STATUS:
      return {
        ...state,
        vendorCategoryStatus: 0,
        vendorCategoryErrorMessage: null,
      };

    // GET Vendor Category  BY ID
    case GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS:
      return {
        ...state,
        isLoading: true,
        vendorCategoryErrorMessage: null,
        modalActive: false,
        vendorCategoryData: null,
      };
    case GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorCategoryData: payload.data,
        vendorCategoryDataStatus: payload.status,
        vendorCategoryErrorMessage: null,
      };
    case GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorCategoryErrorMessage: payload,
        vendorCategoryData: null,
      };
    case GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS_STATUS:
      return {
        ...state,
        vendorCategoryData: null,
      };

    ///Active Vendor Category List
    case GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY:
      return {
        ...state,
        isLoading: true,
        assetTypeErrorMessage: null,
        modalActive: false,
        ActiveVendorCategoryList: null,
      };
    case GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        ActiveVendorCategoryList: payload.data,
        assetTypeErrorMessage: null,
      };
    case GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY_REJECTED:
      return {
        ...state,
        isLoading: false,
        assetTypeErrorMessage: payload,
        ActiveVendorCategoryList: null,
      };
    case GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY_STATUS:
      return {
        ...state,
        ActiveVendorCategoryList: null,
      };

    //SAVE Vendor Register
    case SaveVendorRegisterActions.SAVE_VENDOR_REGISTER:
      return {
        ...state,
        isLoading: true,
        vendorRegisterErrorMessage: null,
        modalActive: false,
      };
    case SaveVendorRegisterActions.SAVE_VENDOR_REGISTER_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorRegisterStatus: payload.status,
        vendorRegisterErrorMessage: null,
        vendorRegisterSuccessMessage: "Vendor Register Added Successfully!",
      };

    case SaveVendorRegisterActions.SAVE_VENDOR_REGISTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        vendorRegisterStatus: null,
        vendorRegisterErrorMessage: payload,
      };
    case SaveVendorRegisterActions.SAVE_VENDOR_REGISTER_STATUS:
      return {
        ...state,
        vendorRegisterStatus: 0,
        vendorRegisterErrorMessage: null,
      };

    // GET Vendor Register  BY ID
    case GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS:
      return {
        ...state,
        isLoading: true,
        vendorRegisterErrorMessage: null,
        modalActive: false,
        vendorRegisterData: null,
      };
    case GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorRegisterData: payload.data,
        vendorRegisterDataStatus: payload.status,
        vendorRegisterErrorMessage: null,
      };
    case GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorRegisterErrorMessage: payload,
        vendorRegisterData: null,
      };
    case GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS_STATUS:
      return {
        ...state,
        vendorRegisterData: null,
      };

    // DELETE Vendor Address  BY ID
    case DeleteVendorAddressActions.DELETE_VENDOR_ADDRESS_DETAILS:
      return {
        ...state,
        isLoading: true,
        vendorAddressErrorMessage: null,
      };
    case DeleteVendorAddressActions.DELETE_VENDOR_ADDRESS_DETAILS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        vendorAddressErrorMessage: null,
      };
    case DeleteVendorAddressActions.DELETE_VENDOR_ADDRESS_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorAddressErrorMessage: payload,
      };

    // DELETE Vendor CONTACT  BY ID
    case DeleteVendorContactActions.DELETE_VENDOR_CONTACT_DETAILS:
      return {
        ...state,
        isLoading: true,
        vendorContactErrorMessage: null,
      };
    case DeleteVendorContactActions.DELETE_VENDOR_CONTACT_DETAILS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        vendorContactErrorMessage: null,
      };
    case DeleteVendorContactActions.DELETE_VENDOR_CONTACT_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorContactErrorMessage: payload,
      };

    ///Active Vendors
    case GetActiveVendorActions.FETCH_ACTIVE_VENDORS:
      return {
        ...state,
        isLoading: true,
        vendorErrorMessage: null,
        modalActive: false,
        ActiveVendorList: null,
      };
    case GetActiveVendorActions.FETCH_ACTIVE_VENDOR_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        ActiveVendorList: payload.data,
        vendorErrorMessage: null,
      };
    case GetActiveVendorActions.FETCH_ACTIVE_VENDOR_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorErrorMessage: payload,
        ActiveVendorList: null,
      };
    case GetActiveVendorActions.FETCH_ACTIVE_VENDOR_STATUS:
      return {
        ...state,
        ActiveVendorList: null,
      };


    // GET Vendor TnC Documents BY Vendot ID
    case GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS:
      return {
        ...state,
        isLoading: true,
        vendorTnCDocumentsErrorMessage: null,
        vendorTnCDocumentsData: null,
      };
    case GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorTnCDocumentsData: payload.data,
        vendorTnCDocumentsDataStatus: payload.status,
        vendorTnCDocumentsErrorMessage: null,
      };
    case GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorTnCDocumentsErrorMessage: payload,
        vendorTnCDocumentsData: null,
      };
    case GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS_STATUS:
      return {
        ...state,
        vendorTnCDocumentsData: null,
      };

    //SAVE Vendor Terms and Conditions Documents
    case SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS:
      return {
        ...state,
        isLoading: true,
        vendorTnCDocumentsErrorMessage: null,
        modalActive: false,
      };
    case SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        vendorTnCDocumentsStatus: payload.status,
        vendorTnCDocumentsErrorMessage: null,
        vendorTnCDocumentsSuccessMessage:
          "Vendor Documents Added Successfully!",
      };

    case SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        vendorTnCDocumentsStatus: null,
        vendorTnCDocumentsErrorMessage: payload,
      };
    case SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS_STATUS:
      return {
        ...state,
        vendorTnCDocumentsStatus: 0,
        vendorTnCDocumentsErrorMessage: null,
      };

    // DELETE Vendor Terms And Conditions BY Vendor ID
    case DeleteVendorTnCDocumentsActions.DELETE_VENDOR_TNC_DOCUMENTS_DETAILS:
      return {
        ...state,
        isLoading: true,
        vendorTnCDocumentsErrorMessage: null,
      };
    case DeleteVendorTnCDocumentsActions.DELETE_VENDOR_TNC_DOCUMENTS_DETAILS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        vendorTnCDocumentsErrorMessage: null,
      };
    case DeleteVendorTnCDocumentsActions.DELETE_VENDOR_TNC_DOCUMENTS_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        vendorTnCDocumentsErrorMessage: payload,
      };
    //view document details by id
     case GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS:
      return {
        ...state,
        isLoading: true,
        venderViewErrorMsg: null,
        venderViewDocumentData: null,
      };
    case GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        venderViewDocumentData: payload.data,
        venderViewDocumentDataStatus: payload.status,
        venderViewErrorMsg: null,
      };
    case GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS_REJECTED:
      return {
        ...state,
        isLoading: false,
        venderViewErrorMsg: payload,
        venderViewDocumentData: null,
      };
    case GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS_STATUS:
      return {
        ...state,
        venderViewDocumentData: null,
      };
      //
      //SAVE Vendor Terms and Conditions Documents
    case UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT:
      return {
        ...state,
        isLoading: true,
        uploadDocErrorMessage: null,
        modalActive: false,
      };
    case UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        uploadDocStatus: payload.status,
        uploadDocErrorMessage: null,
        uploadDocSuccessMessage:
          "Vendor Documents Uploaded Successfully!",
      };

    case UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        cc: null,
        uploadDocErrorMessage: payload,
      };
    case UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT_STATUS:
      return {
        ...state,
        uploadDocStatus: 0,
        uploadDocErrorMessage: null,
      };

    // clear assetType details
    case ClearFormDetailsActions.CLEAR_FORM_DETAILS:
      return {
        ...state,
        GetIndustryType: null,
        IndustryTypeStatus: null,
        industrySuccessMessage: null,
        GetIndustryTypeStatus: null,
        IndustryTypeData: null,
        GetVendorType: null,
        vendorTypeStatus: null,
        vendorTypeSuccessMessage: null,
        GetVendorTypeStatus: null,
        vendorTypeData: null,
        GetVendorCategory: null,
        vendorCategoryStatus: null,
        vendorCategorySuccessMessage: null,
        GetVendorCategoryStatus: null,
        vendorCategoryData: null,
        GetVendorRegister: null,
        vendorRegisterStatus: null,
        vendorRegisterSuccessMessage: null,
        GetVendorRegisterStatus: null,
        vendorRegisterData: null,
        vendorAddressErrorMessage: null,
        vendorContactErrorMessage: null,
        GetVendorTnCDocuments: null,
        vendorTnCDocumentsStatus: null,
        vendorTnCDocumentsSuccessMessage: null,
        GetVendorTnCDocumentsStatus: null,
        vendorTnCDocumentsData: null,
        vendorTnCDocumentsErrorMessage: null,
        venderViewDocumentData:null,
        venderViewErrorMsg:null
      };

    case GetVendorPortalDashboardActions.GET_VENDOR_PORTAL_DASHBOARD_SUCCESS:
      return {
        ...state,
        vendorPortalDashboard: payload,
        vendorPortalDashboardError: null,
      };

    case GetVendorPortalDashboardActions.GET_VENDOR_PORTAL_DASHBOARD_FAILURE:
      return {
        ...state,
        vendorPortalDashboard: null,
        vendorPortalDashboardError: payload,
      };

    default:
      return state;
  }
}
